import { defineMessages } from 'react-intl';
import { CategoryGroup } from './categories-list';

export const messages = defineMessages({
  modalTitle: {
    id: 'cash_flow_modal.title',
    defaultMessage: 'Detailed information',
    description: 'Title of cash flow modal',
  },
  modalCategory: {
    id: 'cash_flow_modal.category',
    defaultMessage: 'Category',
    description: 'Title of the category section',
  },
  modalCurrentCategory: {
    id: 'activity_modal.category',
    defaultMessage: 'Current category',
    description: 'Title of the current category section',
  },
  modalTransaction: {
    id: 'cash_flow_modal.transactions',
    defaultMessage: 'Transactions',
    description: 'Title of the transactions section',
  },
  modalSubmitButton: {
    id: 'cash_flow_modal.submit_button',
    defaultMessage: 'Submit',
    description: 'Submit button of modal',
  },
  modalCancelButton: {
    id: 'cash_flow_modal.cancel_button',
    defaultMessage: 'Cancel',
    description: 'Cancel button of modal',
  },
  type: {
    id: 'cash_flow_modal.type.title',
    defaultMessage: 'Type',
    description: 'Title of type cell in modal',
  },
  transactions: {
    id: 'cash_flow_modal.type.transactions',
    defaultMessage: 'Transactions',
    description: 'Title of the transactions cell in modal',
  },
  commonBankStatement: {
    id: 'cash_flow_modal.type.commonBankStatement',
    defaultMessage: 'Common bank statement',
    description: 'Title of the common bank statement cell in modal',
  },
  for: {
    id: 'cash_flow_modal.for',
    defaultMessage: 'for',
  },
  incoming: {
    id: 'cash_flow_modal.transactions.nature.incoming',
    defaultMessage: 'Incoming',
    description: 'title incoming for nature of transaction',
  },
  outgoing: {
    id: 'cash_flow_modal.transactions.nature.outgoing',
    defaultMessage: 'Outgoing',
    description: 'title outgoing for nature of transaction',
  },
  placeholderInput: {
    id: 'cash_flow_modal.transactions.input.placeholder',
    defaultMessage: 'Enter or select a category',
    description: 'message of placeholder input',
  },
  validationMessage: {
    id: 'cash_flow_modal.validation_message',
    defaultMessage: 'Warning, if you change the category, the folder will be automatically updated.',
    description: 'message to validate the category',
  },
  commonCellTitle: {
    id: 'common_cell.title',
    defaultMessage: 'Libellé commun',
    description: 'Title of common cell',
  },
  oldCategory: {
    id: 'activity.old_category',
    defaultMessage: 'Old category',
    description: 'Old category title',
  },
  transactionsCellContent: {
    id: 'transactions_cell.content',
    defaultMessage: '<b>{number}</b> for <b>{totalAmount}</b>',
    description: 'Content of transactions cell',
  },
});

export const categoryGroupMessages = defineMessages({
  [CategoryGroup.INFLOW]: {
    id: 'cash_flow_modal.transactions.category_group.INFLOW',
    defaultMessage: 'Inflows',
    description: 'Title of the inflow category group',
  },
  [CategoryGroup.EXPENSE]: {
    id: 'cash_flow_modal.transactions.category_group.EXPENSE',
    defaultMessage: 'Expenses',
    description: 'Title of the expense category group',
  },
  [CategoryGroup.CREDIT]: {
    id: 'cash_flow_modal.transactions.category_group.CREDIT',
    defaultMessage: 'Credits',
    description: 'Title of the credit category group',
  },
  [CategoryGroup.SAVING]: {
    id: 'cash_flow_modal.transactions.category_group.SAVING',
    defaultMessage: 'Savings',
    description: 'Title of the saving category group',
  },
  [CategoryGroup.BANK_OPERATION]: {
    id: 'cash_flow_modal.transactions.category_group.BANK_OPERATION',
    defaultMessage: 'Banking operations',
    description: 'Title of the bank operation category group',
  },
  [CategoryGroup.REFUND]: {
    id: 'cash_flow_modal.transactions.category_group.REFUND',
    defaultMessage: 'Refunds',
    description: 'Title of the refund category group',
  },
  [CategoryGroup.TAX]: {
    id: 'cash_flow_modal.transactions.category_group.TAX',
    defaultMessage: 'Taxes',
    description: 'Title of the tax category group',
  },
});
